import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const BudgetsPage = lazy(() => import('@/containers/Views/Budgets/BudgetsPage'));
const BudgetDetails = lazy(() => import('@/containers/Views/Budgets/BudgetDetails'));
const BudgetCreatePage = lazy(() => import('@/containers/Views/Budgets/BudgetCreatePage'));
const BudgetEditPage = lazy(() => import('@/containers/Views/Budgets/BudgetEditPage'));

const BudgetsRouter = (
  <Route path="budgets">
    <Route
      index
      element={(
        <PrivateRoute
          pageName={EPage.Budgets}
          permissions={EBasicActions.Find}
        >
          <BudgetsPage />
        </PrivateRoute>
      )}
    />
    <Route
      path="new"
      element={(
        <PrivateRoute
          pageName={EPage.Budgets}
          permissions={EBasicActions.Find}
        >
          <BudgetCreatePage />
        </PrivateRoute>
      )}
    />
    <Route
      path=":id"
      element={(
        <PrivateRoute
          pageName={EPage.Budgets}
          permissions={EBasicActions.Find}
        >
          <BudgetDetails />
        </PrivateRoute>
      )}
    />
    <Route
      path=":id/edit"
      element={(
        <PrivateRoute
          pageName={EPage.Budgets}
          permissions={EBasicActions.Find}
        >
          <BudgetEditPage />
        </PrivateRoute>
      )}
    />
  </Route>
);

export default BudgetsRouter;
